import React, { useEffect, useState } from 'react'
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import { BlockUI, AlertMessage, BootstrapAlertMessage } from '../../Utility.jsx';
import { trim } from '../../../helpers/String.js';
import ColorizeIcon from '@mui/icons-material/Colorize';
import { Sketch } from '@uiw/react-color';

import {
  Button,
  InputLabel,
  TextField,
  TextareaAutosize
} from '@mui/material';

export const MappingLayoutCanvas = React.memo(({ canvasRef, layoutId }) => {            
    return <canvas className={`border ${layoutId === '' ? 'd-none' : 'd-block'}`} ref={canvasRef}></canvas>
});

export const FormRackDetail = ({selectedRack, setSelectedRack, rackTypeList, rackCategoryList, handleApply, handleClose, applyResponseMessages}) => {
    const [ rack, setRack ] = useState(selectedRack);
    const [ isSubmit, setIsSubmit ] = useState(false);
    const handleRackCategoryChange = (event) => {
        let value = event.target.value;
        let newSelectedValue = (typeof value === 'string' ? value.split(',') : value);
        setRack(prevValue => ({ ...prevValue, RackCategoryListId: newSelectedValue }));
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputData = Object.fromEntries(formData.entries());
        const updatedRack = Object.assign({}, selectedRack, inputData);
        updatedRack.RackCategoryListId = updatedRack.RackCategoryListId.split(',')
        setSelectedRack(updatedRack);
        setIsSubmit(true);
    }

    useEffect(() => {        
        if (isSubmit) {
            handleApply();
            setIsSubmit(false);
        }
    }, [isSubmit]);
    
    return (
        <form onSubmit={handleFormSubmit}>
            <div className="body p-3">
                <div className="row">
                    {<AlertMessage type={"error"} messages={applyResponseMessages} />}
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <InputLabel>Rack No</InputLabel>
                        <TextField name="RackId" defaultValue={rack.RackId} variant="standard" />
                    </div>
                    <div className="col-md-6">
                        <InputLabel>Rack Name</InputLabel>
                        <TextField name="RackName" defaultValue={rack.RackName} variant="standard" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <InputLabel>Rack Type</InputLabel>
                        <Select
                            className="w-100"
                            name="RackTypeId"                            
                            defaultValue={rack.RackTypeId}
                            labelId="my-select-label"                            
                            >
                            {rackTypeList && 
                                rackTypeList.map((d) => (
                                <MenuItem key={d.value} value={d.value}>{d.text}</MenuItem>
                            ))}                         
                        </Select>
                    </div>
                    <div className="col-md-12">
                        <InputLabel>Rack Category</InputLabel>
                        <Select                         
                            name="RackCategoryListId"
                            className="w-100"
                            multiple
                            value={rack.RackCategoryListId}
                            onChange={handleRackCategoryChange}
                            input={<OutlinedInput label="Tag" />}
                            renderValue={(selected) => {  
                                let selectedText = rackCategoryList.filter(d => selected.includes(d.value)).map(d => d.text); 
                                return selectedText.join(','); 
                            }}
                        >
                        {rackCategoryList && 
                            rackCategoryList.map((d) => (
                            <MenuItem key={d.value} value={d.value}>
                                <Checkbox checked={rack.RackCategoryListId.includes(d.value)} />
                                <ListItemText primary={d.text} />
                            </MenuItem>
                        ))}
                        </Select>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <InputLabel>Notes</InputLabel>
                        <TextareaAutosize
                            className="w-100"
                            name="Notes"
                            aria-label=""
                            minRows={4}
                            placeholder="Notes"
                            defaultValue={rack.Notes}
                        />
                    </div>
                </div>
            </div>
            <div className="row p-3">
                <div className="col-lg-12 text-end">
                    <Button type="button" onClick={handleClose}>Close</Button>
                    <Button type="submit" variant="contained">Apply</Button>
                </div>          
            </div>
        </form>
    );
}

export const FormAddText = ({ fontList = [], handleApplyAddText, handleClose }) => {
    const [ color, setColor ] = useState("#000000");
    const [ showColorPicker, setShowColorPicker ] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputData = Object.fromEntries(formData.entries());

        if (trim(inputData.inputLabel) == '') {            
            return;
        }

        handleApplyAddText(inputData);        
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="body p-3">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <InputLabel>Label</InputLabel>
                            <TextField name="inputLabel" defaultValue={""} variant="standard" />
                        </div>
                        <div className="col-md-6">
                            <InputLabel>Font</InputLabel>
                            <Select
                                className="w-100"
                                name="fontFamily"
                                defaultValue={fontList[0].value}
                                labelId="my-select-label"
                                >
                                {fontList && 
                                    fontList.map((d) => (
                                    <MenuItem key={d.value} value={d.value}>{d.text}</MenuItem>
                                ))}                         
                            </Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <InputLabel>Color (Hex)</InputLabel>
                            <TextField className="col-md-8 col-sm-8" name="fill" value={color} variant="standard" onChange={(e) => setColor(e.target.value)} />
                            <Button className="col-md-4 col-4" onClick={()=> { 
                                setShowColorPicker(!showColorPicker);
                                }}><ColorizeIcon />
                            </Button>
                             {showColorPicker &&
                                <Sketch
                                    className={"position-absolute"}
                                    color={color}
                                    onChange={(color) => {
                                        setColor(color.hex);
                                    }}
                                />
                            }
                        </div>

                        <div className="col-md-6">
                            <InputLabel>Font Size</InputLabel>
                            <TextField type="number" name="fontSize" defaultValue={"40"}variant="standard" />
                        </div>
                    </div>
                </div>
                <div className="row p-3">
                    <div className="col-lg-12 text-end">
                        <Button type="button" onClick={handleClose}>Close</Button>
                        <Button type="submit" variant="contained" >Apply</Button>
                    </div>          
                </div>
            </form>
        </>
    );
}

export const GuidanceMappingLayout=()=>{
    return(
        <div className="row p-3">
            <div className="col-lg-12">
                <p>*Click rack to show rack detail form. Press apply after done making changes.</p>
                <p>*Click button Add Text to show form. Press apply to add text object on layout.</p>
                <p>*Hold ctrl + mouse hover to disabled rack (This only works on empty rack. Disabled rack turns into gray and rack(s) are not showing on the report).</p>
                <p>*Hold alt + mouse hover to enable rack.</p>
                <p>*Select multiple racks with holding down mouse right button and released after selecting area done after that press unassiged rack button.</p>
                <p>*To make disabled / enabled functionality works as it is you need to press refresh button after you done perform disabled / enabled multiple racks.</p>
                <p>*Click Save to save all changes.</p>
            </div>
        </div>
    );
}